/**
 * Primary screening-stage mapping from the loaded detail payload.
 */

import { useEligibilityDetailContext } from "../../EligibilityDetailContext";
import { EvaluationStageTab } from "../EvaluationStageTab";

/**
 * Render primary questions and nested atoms from `detail.latest_screening`.
 *
 * @returns Data-driven primary-stage mapping
 */
const PrimaryEvaluationTab = () => {
  const { detail } = useEligibilityDetailContext();
  const stage = detail.latest_screening?.stages?.find(
    (item) => item.stage === "primary",
  );
  return (
    <EvaluationStageTab
      heading="Primary Evaluation"
      stage={stage}
      overrides={detail.overrides}
    />
  );
};

export default PrimaryEvaluationTab;
